<template>
  <custom-popup v-model="dialog" :cons="{ title: 'انتخاب کارت NFC' }">
    <v-row class="pa-2" no-gutters>
      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-text-field
          class="rounded-lg"
          clearable
          dense
          label="جستجو"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-select
          :menu-props="{ offsetY: true }"
          class="rounded-lg"
          clearable
          dense
          label="رنگ"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-select
          :items="[
            { value: 'horizontal', text: 'افقی' },
            { value: 'vertical', text: 'عمودی' },
          ]"
          :menu-props="{ offsetY: true }"
          class="rounded-lg"
          clearable
          dense
          label="نوع کارت"
          outlined
        />
      </v-col>

      <v-col
        v-for="(item, i) in list"
        :key="i"
        class="pa-3 fill-height deck-col"
        cols="12"
        md="4"
      >
        <v-card class="rounded-0" outlined>
          <div class="pa-4 overflow-hidden text-center">
            <div
              :class="{ horizontal: item.orientation === 'horizontal' }"
              class="deck"
            >
              <div :class="{ flipped: flipped }" class="card">
                <div class="front face">
                  <v-img
                    :aspect-ratio="
                      item.orientation === 'horizontal' ? 1.615 : 0.619
                    "
                    :src="item?.front_image"
                  />
                </div>
                <div class="back face">
                  <v-img
                    :aspect-ratio="
                      item.orientation === 'horizontal' ? 1.615 : 0.619
                    "
                    :src="item?.back_image"
                  />
                </div>
              </div>
            </div>
          </div>
        </v-card>

        <v-card-actions class="justify-center">
          <v-btn
            block
            class="rounded-lg white--text"
            color="red darken-2"
            depressed
            @click="addNfc(item)"
          >
            انتخاب
          </v-btn>
        </v-card-actions>
      </v-col>

      <template v-if="!isLastPage || loading">
        <v-col
          v-for="loader in 3"
          :key="`loader-${loader}`"
          class="pa-8"
          cols="12"
          md="4"
        >
          <v-skeleton-loader min-height="300" type="image" />
        </v-col>
      </template>

      <v-col cols="12">
        <v-card
          v-if="!loading && !isLastPage && !getError"
          v-intersect="onIntersect"
          flat
          height="200"
        />
      </v-col>
    </v-row>
  </custom-popup>
</template>

<script>
export default {
  name: "showAllNfcList",

  props: {
    value: Boolean,
  },

  data() {
    return {
      list: [],
      loading: false,
      isLastPage: false,
      getError: false,
      isIntersecting: false,
      flipped: false,
      tableProps: {
        page: 1,
        length: 10,
        search: "",
        color: "",
      },
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(val) {
      !!val && !this.list?.length && this.fetchNfc();
    },
  },

  methods: {
    fetchNfc(params = this.tableProps) {
      this.loading = true;

      this.$api
        .get("/v2/special-nfc", { params })
        .then((res) => {
          this.isLastPage = !res.data.data.data.next_page_url;
          this.getError = false;
          this.isIntersecting = false;

          this.list = [...this.list, ...res.data.data.data.data];
          const { data, ...rest } = res.data.data.data;
          this.data = { ...rest };
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || "خطا در دریافت لیست کارت‌های NFC!",
          );
          this.getError = true;
        })
        .finally(() => (this.loading = false));
    },
    onIntersect(entries, observer) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if (this.isIntersecting && !!this.list.length && !this.isLastPage) {
          this.tableProps.page++;
          this.$nextTick(() => this.fetchNfc());
        }
      });
    },
    addNfc(item) {
      this.dialog = false;
      this.$emit("select", item);
    },
  },
};
</script>

<style scoped>
.deck-col .v-card__actions {
  visibility: hidden;
}

.deck-col:hover .v-card__actions {
  visibility: visible;
}

.deck {
  margin: auto;
  width: 100%;
  max-width: 150px;
  height: auto;
  aspect-ratio: 0.619;
  position: relative;
  -webkit-perspective: 1000px;
  perspective: 1000px;
  border-radius: 10px;

  &.horizontal {
    aspect-ratio: 1.615;
    max-width: 95%;
  }
}

.card {
  width: 100%;
  height: 100%;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
  border-radius: 10px;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);
}

.face {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: whitesmoke;
  border-radius: 10px;
}

.back {
  overflow: hidden;
  z-index: -1;
  display: block;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  box-sizing: border-box;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-size: 100% 100%;
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }
}

.front,
.back {
  transition: all 0.5s linear;
}

.front {
  z-index: 1;
}

.flipped,
.card:hover {
  box-shadow: 0 0 7px 4px rgba(0, 0, 0, 0.2);
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
</style>
